module.exports = "/_next/static/images/8e03edba55d7aa72debb39ac47595184-help-icon.svg.webp";